import React from 'react';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import LoadingSpinner from 'components/LoadingSpinner';

ChartJS.register(...registerables);
ChartJS.register(ChartDataLabels);

export default function LinearGraphComponent({
  type = 'bar',
  data1,
  data2,
  chartX,
  isLoading,
}: {
  type?: 'bar' | 'line';
  data1: {
    name: string;
    data: Array<number>;
  };
  data2: {
    name: string;
    data: Array<number>;
  };
  chartX: Array<string>;
  isLoading: boolean;
}) {
  return (
    <>
      {isLoading ? (
        <div className="flex flex-1 justify-center">
          <LoadingSpinner content="Buscando información" />
        </div>
      ) : [...data1.data, ...data2.data].reduce((a, b) => a + (b || 0), 0) === 0 ? (
        <div className="flex flex-1 justify-center">No se encontraron datos</div>
      ) : (
        <div className="flex">
          <Chart
            type="scatter"
            options={{
              responsive: true,
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'right',
                  ticks: {
                    font: {
                      size: 14,
                    },
                  },
                },
                y1: {
                  beginAtZero: true,
                  ticks: {
                    font: {
                      size: 14,
                    },
                  },
                },
              },
            }}
            data={{
              labels: chartX,
              datasets: [
                {
                  type,
                  label: data1.name,
                  data: data1.data || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  fill: true,
                  borderColor: 'rgba(255, 99, 132, 0.5)',
                  backgroundColor: 'rgba(255, 99, 132, 0.5)',
                  yAxisID: 'y',
                },
                {
                  type,
                  label: data2.name,
                  data: data2.data || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  fill: true,
                  borderColor: 'rgba(54, 162, 235, 0.5)',
                  backgroundColor: 'rgba(54, 162, 235, 0.5)',
                  yAxisID: 'y1',
                },
              ],
            }}
          />
        </div>
      )}
    </>
  );
}
